import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	content: {
		width: 520,
		boxSizing: 'border-box',
		maxHeight: '65vh',
		overflowY: 'auto',
	},
	loadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		paddingTop: 48,
		paddingBottom: 48,
	},
	errorContainer: {
		padding: THEME.spacing.lg,
		textAlign: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		alignItems: 'center',
	},
	stepContainer: {
		display: 'flex',
		flexDirection: 'column',
	},
	stepTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.sm,
		marginTop: THEME.spacing.none,
	},
	stepLoadingContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		paddingTop: THEME.spacing.xl,
		paddingBottom: THEME.spacing.xl,
	},
	emptyState: {
		textAlign: 'center',
		paddingTop: THEME.spacing.xl,
		paddingBottom: THEME.spacing.xl,
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	errorText: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		paddingTop: THEME.spacing.md,
		paddingBottom: THEME.spacing.md,
	},
	stepDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		marginBottom: THEME.spacing.md,
	},
	checkboxGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxHeight: '60%',
		overflowY: 'auto',
		marginBottom: THEME.spacing.lg,
	},
	checkboxLabel: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.spacing.sm,
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			borderColor: THEME.colors.border.main,
			backgroundColor: THEME.colors.background.light,
		},
	},
	radioGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		maxHeight: '60%',
		overflowY: 'auto',
		marginBottom: THEME.spacing.lg,
	},
	radioLabel: {
		display: 'flex',
		alignItems: 'flex-start',
		padding: THEME.spacing.md,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.spacing.sm,
		cursor: 'pointer',
		transition: 'all 0.2s',
		':hover': {
			borderColor: THEME.colors.border.main,
			backgroundColor: THEME.colors.background.light,
		},
	},
	radioInput: {
		marginTop: THEME.spacing.xs,
		marginRight: THEME.spacing.sm,
		cursor: 'pointer',
	},
	accountName: {
		fontSize: THEME.typography.fontSizes.md,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.main,
	},
	businessName: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	buttonGroup: {
		display: 'flex',
		gap: THEME.spacing.md,
		justifyContent: 'flex-start',
		marginTop: THEME.spacing.lg,
	},
});
